import { useQuery } from '@tanstack/react-query';
import { configCenterApi } from '../api/configCenterApi';
import type { ConfigListFilter } from '../types/configCenter';

/**
 * GET /api/eraf/config-center — 설정 목록 (CONFIG_CENTER_READ)
 * queryKey: ['config-center', 'list', filters]
 */
export function useConfigList(filters: ConfigListFilter) {
  return useQuery({
    queryKey: ['config-center', 'list', filters],
    queryFn: () =>
      configCenterApi.list({
        category: filters.category || undefined,
        keyword: filters.keyword || undefined,
        sensitiveOnly: filters.sensitiveOnly,
        page: filters.page ?? 0,
        size: filters.size ?? 20,
        sort: filters.sort ?? 'configKey,asc',
      }),
    staleTime: 30_000,
  });
}
